<template>
<svg data-svg-lvl-3="spread-block-spread" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 514 430"><defs><clipPath id="ls-cp"><rect class="ls-c-1" x="114.68" y="200.12" width="284.68" height="189.61"/></clipPath></defs><g id="Разворот"><g class="ls-c-4"> <rect :style="{ fill: params.slice.color }"  class="ls-c-1" x="114.68" y="200.12" width="284.68" height="189.61"/> <image width="1084" height="722" transform="translate(114.68 200.12) scale(0.26)" :href="params.blockImage"  v-show="params.blockImage" preserveAspectRatio="xMidYMid slice" /></g></g></svg></template>


<script>
/** Этот компонент генерируется автоматически, руками ничего менять нельзя!!! */
  
export default {props: { params: { type: Object, required: true, }, }, data() { return {} },}
</script>

<style scoped>.ls-c-1{fill:none;}.ls-c-2{opacity:0.3;}.ls-c-3{fill:#64ff00;}.ls-c-4{clip-path:url(#ls-cp);}</style>

